<template>
  <div class="container">
    <!-- <div class="card"> -->
    <div class="header">
      <button class="back-button" @click="back">

        <div class="cont-button-back-icon">
          <svg width="7.492188" height="15.406250" viewBox="0 0 7.49219 15.4062" fill="none"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs />
            <path id="Line" d="M6.78 14.7L1.34 9.25C0.48 8.4 0.48 7 1.34 6.14L6.78 0.7" stroke="currentColor"
              stroke-opacity="1.000000" stroke-width="1.400000" stroke-linejoin="round" stroke-linecap="round" />
          </svg>
        </div>

        <p class="back-button-text">Надіслати відгук</p>
      </button>
    </div>

    <div class="content">
      <div class="rating-title-c">
        <p class="rating-title-g">Ваша думка важлива для нас! 😊</p>
      </div>

      <div class="rating-section">
        <p class="rating-title">Оцінка кухні</p>
        <div class="stars">
          <svg v-for="star in 5" :key="'kitchen-' + star" @click="setRating('kitchen', star)"
            @mouseover="hoverRating.kitchen = star" @mouseleave="hoverRating.kitchen = 0" class="star"
            :class="{ 'active': star <= (hoverRating.kitchen || rating.kitchen) }" xmlns="http://www.w3.org/2000/svg"
            width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round">
            <polygon
              points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
            </polygon>
          </svg>
          <span class="rating-score">{{ rating.kitchen }}/5</span>
        </div>
        <p class="rating-text">{{ getRatingText(rating.kitchen) }}</p>
      </div>

      <div class="rating-section">
        <p class="rating-title">Оцінка обслуговування</p>
        <div class="stars">
          <svg v-for="star in 5" :key="'service-' + star" @click="setRating('service', star)"
            @mouseover="hoverRating.service = star" @mouseleave="hoverRating.service = 0" class="star"
            :class="{ 'active': star <= (hoverRating.service || rating.service) }" xmlns="http://www.w3.org/2000/svg"
            width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round">
            <polygon
              points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
            </polygon>
          </svg>
          <span class="rating-score">{{ rating.service }}/5</span>
        </div>
        <p class="rating-text">{{ getRatingText(rating.service) }}</p>
      </div>

      <textarea v-model="comment" class="comment-box" placeholder="Напишіть ваш коментар..."></textarea>

      <div class="rating-section-contact">
        <p class="rating-title-contact">Будь ласка, залиште свої контакти</p>
        <input class="rating-title-form" v-model="clientPhone" placeholder="+380..." />
        <input class="rating-title-form" v-model="clientName" placeholder="Ім’я (необов’язково)" />
      </div>

      <loader v-if="loader"></loader>
      <button class="submit-button" @click="sendReview" :disabled="loader">
        <span v-if="!loader">Залишити відгук</span>
        <span v-else>Надсилання...</span>
      </button>
    </div>
    <footer>
      <span class="footer-title">
        Powered by
        <a class="footer-text" target="_blank" rel="noopener noreferrer"
          href="https://skyservice.pro">Skyservice POS</a>
      </span>
    </footer>
    <div v-if="showThanksDialog" class="thanks-dialog">
      <div class="thanks-card">
        <h2 class="thanks-title">🎉 Дякуємо за ваш відгук!</h2>
        <p class="thanks-text">Нам дуже приємно отримати вашу думку 💛</p>
        <button class="thanks-button" @click="back">На головну</button>
      </div>
    </div>

  </div>

  <!-- </div> -->
</template>

<script>
import { navigator } from './configRoutes';
import { Review } from "@/components/API.js";
import Loader from "@/components/Loader.vue";

let apiReview = new Review();


export default {
  data() {
    return {
      rating: {
        kitchen: 5,
        service: 5
      },
      hoverRating: {
        kitchen: 0,
        service: 0
      },
      comment: '',
      clientPhone: '',
      clientName: '',
      loader: false,
      showThanksDialog: false, // 👈 нова змінна

    };
  },
  components: {
    Loader,
  },
  methods: {
    // Відправка відгуків
    sendReview() {
      // Створюємо об'єкт з обов'язковими полями для API
      const payload = {
        kitchenRating: this.rating.kitchen,
        serviceRating: this.rating.service,
        comment: this.comment.trim(),
      };

      // Вмикаємо індикатор завантаження — блокуємо кнопку
      this.loader = true;

      // Додаємо номер телефону, якщо користувач його ввів
      if (this.clientPhone.trim()) {
        payload.clientPhone = this.clientPhone.trim().replace(/\D/g, ''); // залишаємо лише цифри
      }

      // Додаємо ім’я, якщо користувач його ввів
      if (this.clientName.trim()) {
        payload.clientName = this.clientName.trim();
      }

      // Відправляємо запит до API
      return apiReview.sendReview(payload)
        .then(response => {
          // Якщо сервер відповів статусом "done", показуємо повідомлення про успіх
          if (response.status === 'done') {

            this.showThanksDialog = true; // 👈 показуємо діалог
            // Опціонально: очищення форми
            // this.resetForm();
          } else {
            // Якщо відповідь з іншим статусом — теж показуємо повідомлення
            console.warn('Неочікуваний статус відповіді', response);
            alert('Щось пішло не так. Спробуйте ще раз.');
          }
        })
        .catch(error => {
          // Обробка помилки, якщо API-запит не вдався
          console.error('Помилка при надсиланні відгуку', error);
          alert('Сталася помилка. Спробуйте ще раз.');
        })
        .finally(() => {
          // Вимикаємо індикатор завантаження — розблоковуємо кнопку
          this.loader = false;
        });
    },


    back() {
      this.$emit("changePage", navigator.START_PAGE);
      const url = new URL(window.location.href);
      url.searchParams.delete('skyservice');
      window.history.pushState(null, '', url.toString());
    },
    setRating(category, value) {
      this.rating[category] = value;
    },
    getRatingText(value) {
      return value === 5 ? 'Відмінно' :
        value === 4 ? 'Добре' :
          value === 3 ? 'Задовільно' :
            value === 2 ? 'Погано' : 'Жахливо';
    },
    // Скидання форми до дефолтних значень
    resetForm() {
      this.rating.kitchen = 5;
      this.rating.service = 5;
      this.hoverRating.kitchen = 0;
      this.hoverRating.service = 0;
      this.comment = '';
      this.clientPhone = '';
      this.clientName = '';
    },
    // submitReview() {
    //   alert('Відгук відправлено!');
    // },
  }
};
</script>

<style scoped>
.container {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  height: 100vh;
  /* background: linear-gradient(to right, #ece9e6, #ffffff); */
  padding: 5px 20px 20px 20px;
  background: var(--app-bg) !important;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.rating-title-c {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 41px;

}

.rating-title-g {
  color: rgb(0, 0, 0);
  font-family: "Manrope", serif;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  max-width: 246px;
}

/* .card {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 100%;
  height: 100%;
} */

.header {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
}

.back-button {
  /* background: #ffffff;
  color: #6c757d;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500; */
  padding: 8px 0px;
  cursor: pointer;
  /* transition: background 0.2s ease-in-out, border-color 0.2s; */
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: var(--app-bg) !important;
  ;

}

.cont-button-back-icon {
  /* width: 45pzx; */
  height: 45px;
  background: #F4F4F4;
  border-radius: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--app-bg) !important;
  color: var(--text-head) !important;


}

.back-button-text {
  font-family: "Manrope", serif;
  font-size: 23px;
  font-weight: 800;
  margin-left: 10.5px;
  color: var(--text-head) !important;
}

/* .back-button:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
} */

.back-icon {
  width: 14px;
  height: 14px;
  fill: #6c757d;
}

.content {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0px 6px 14px 0px rgba(67, 67, 67, 0.15);
  padding: 20px;
  background: rgb(255, 255, 255);

}

.rating-section {
  margin-bottom: 25px;
}

.rating-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
  color: #333;
}

.stars {
  display: flex;
  align-items: center;
  gap: 6px;
}

.star {
  cursor: pointer;
  width: 28px;
  height: 28px;
  stroke: #d3d3d3;
  transition: stroke 0.3s ease-in-out, fill 0.3s ease-in-out;
}

.star.active {
  stroke: #ffcc00;
  fill: #ffcc00;
}

.star:hover {
  stroke: #ffdb4d;
  fill: #ffdb4d;
}

.rating-score {
  font-size: 18px;
  color: #b0b0b0;
  margin-left: 5px;
}

.rating-text {
  font-size: 14px;
  color: gray;
  margin-top: 5px;
}

.comment-box {
  width: 100%;
  padding: 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: none;
  min-height: 110px;
  transition: border-color 0.3s;
  margin-bottom: 20px;
  font-size: 14px;
}

.comment-box:focus {
  outline: none;
  border-color: #bbb;
}

.rating-section-contact {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rating-title-contact {
  color: rgb(137, 137, 137);
  font-family: "Manrope", serif;
  font-size: 14px;
  font-weight: 500;
}

.rating-title-form {
  border: 1px solid rgb(221, 221, 221);
  border-radius: 8px;
  background: rgb(255, 255, 255);
  width: 100%;
  height: 33px;
  padding: 0 13.5px;
}

.rating-title-form:focus {
  outline: none;
  border-color: #bbb;
}


.submit-button {
  width: 100%;
  margin-top: 28px;
  height: 46px;
  border-radius: 8px;
  border: none;

  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--button) !important;
  color: var(--text-button) !important;
  font-family: "Manrope", serif;
  font-size: 16px;
  font-weight: 600;
}

.submit-button:hover {
  /* box-shadow: 0px 4px 10px rgba(40, 167, 69, 0.3); */
}

.submit-button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.thanks-dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.thanks-card {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
  text-align: center;
  max-width: 360px;
  width: 100%;
  animation: scaleIn 0.35s ease;
}

.thanks-title {
  font-family: "Manrope", serif;
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 12px;
  color: var(--text-head);
}

.thanks-text {
  font-family: "Manrope", serif;
  font-size: 16px;
  font-weight: 400;
  color: #555;
  margin-bottom: 24px;
}

.thanks-button {
  background: var(--button);
  color: var(--text-button);
  font-family: "Manrope", serif;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-top: 15px;
}

.thanks-button:hover {
  background: #2cc76f;
}

@keyframes scaleIn {
  from {
    transform: scale(0.85);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}



footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 11px;
  background: var(--app-bg) !important;
}

/* Типографіка — як у футері стартової сторінки й AppFooter.vue у qr-menu. */
.footer-title {
  color: rgb(67, 67, 67);
  font-family: "Manrope", serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: var(--text-head) !important;
  /* color: var(--text_innerBody) !important; */
}

.footer-text {
  /* color: rgb(67, 67, 67); */
  font-family: "Manrope", serif;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-head) !important;
  transition: opacity 0.2s ease;
}

.footer-text:hover {
  opacity: 0.8;
}
</style>
